import "core-js/modules/es.array.push.js";
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-dcc6892e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "notice-popup"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 0,
  class: "notice-popup__date"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  class: "notice-popup__actions"
};
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import router from '@/router';
import noticeBell from '@/assets/content/notice-bell.png';
export default {
  __name: 'NoticePopup',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    notice: {
      type: Object,
      required: true
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const visible = computed({
      get: () => props.modelValue,
      set: value => emit('update:modelValue', value)
    });
    const close = () => {
      emit('update:modelValue', false);
    };
    const openDetail = () => {
      close();
      router.push({
        name: 'article',
        params: {
          id: props.notice.id
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        visible: _unref(visible),
        "onUpdate:visible": _cache[0] || (_cache[0] = $event => _isRef(visible) ? visible.value = $event : null),
        title: __props.notice.title,
        footer: null,
        width: 520,
        centered: "",
        "destroy-on-close": "",
        "wrap-class-name": "notice-popup-modal",
        onCancel: close
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
          class: "notice-popup__bell",
          src: _unref(noticeBell),
          alt: "",
          "aria-hidden": "true"
        }, null, 8, _hoisted_2), __props.notice.time ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.notice.time), 1)) : _createCommentVNode("", true), _createElementVNode("div", {
          class: "notice-popup__content",
          innerHTML: __props.notice.content
        }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createVNode(_component_a_button, {
          class: "notice-popup__action",
          onClick: close
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('confirmText')), 1)]),
          _: 1
        }), _createVNode(_component_a_button, {
          type: "primary",
          class: "notice-popup__action",
          onClick: openDetail
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('homeremind6')), 1)]),
          _: 1
        })])])]),
        _: 1
      }, 8, ["visible", "title"]);
    };
  }
};